"use client";

import API_URL from "@packages/lib/server-actions/api-urls";
import makeApiCall from "@packages/lib/server-actions/rest-api";
import { DataLayerGA4AttrType, GA4EventAttrType } from "@packages/lib/types/datalayerGA";
import {
  ClickstreamInterface,
  logClickstreamEvent,
} from "@packages/lib/utlils/clickstream";
import {
  GA4DataLayer,
  GA4DataLayerFn,
  includeTickerTape,
} from "@packages/lib/utlils/helper-function";
import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { GAConstants } from "@packages/shared-components/services/constants";

const TickerTape: React.FC<any> = () => {
  const [tickerTapeList, setTickerTapeList] = useState<any[]>([]);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const pathName = usePathname();
  const isCampaignPage = pathName?.includes("campaigns");
  const isScholarshipPage = pathName?.includes("/money/scholarships") || pathName?.includes("/funding/scholarships");
  useEffect(() => {
    //Get Ticper tape details
    async function getTickerTapeDetails() {
      const data = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}${API_URL?.tickerTape}`,
        method: "GET",
        queryParams: { affiliateId: "220703" },
        headers: {
          "x-api-key": `${process.env.NEXT_PUBLIC_X_API_KEY}`,
        },
      });

      setTickerTapeList(Array.isArray(data) ? data : []);
    }

    // set isMobile function
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);

    handleResize();
    if (!isCampaignPage && !isScholarshipPage) {
      getTickerTapeDetails();
    }

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const statsLog = (tickerContent: any) => {
    const csData: ClickstreamInterface = {
      eventType: "TickerTapeClicked",
      actionType: "Interaction",
      idpcInstitutionId: tickerContent?.collegeId,
    };
    const gaData: GA4EventAttrType = {
      event: GAConstants.track_event,
      event_name: "footer_scroll",
      click_text: tickerContent?.description,
    };
    const gaOldData: DataLayerGA4AttrType = {
      event: "ga_events",
      eventName: "ticker_tape",
      cta_url: tickerContent?.destinationUrl,
    }
    GA4DataLayerFn(gaOldData)
    GA4DataLayer(gaData);
    logClickstreamEvent(csData);
  };

  const descLen = tickerTapeList?.reduce((total, announcement) => {
    return total + (announcement?.description?.length || 0);
  }, 0);

  const animationStyle = {
    animationDuration: `${descLen * 0.5}s`,
  };

  return (
    !!(includeTickerTape() &&
    !isMobile &&
    !isCampaignPage &&
    !isScholarshipPage &&
    tickerTapeList?.length) && (
      <>
        <div className="bg-green-light fixed bottom-0 w-full py-[12px] w-full marquee-container">
          <div
            className="marquee flex gap-[100px] md:gap-[300px] lg:gap-[600px]"
            style={animationStyle}
          >
            {[1, 2, 3].map((_, index_outer) => (
              <ul
                key={`ticker_ul_${index_outer}`}
                className="flex gap-[44px] x-small *:font-semibold uppercase tracking-[1px]  key={index}"
              >
                {tickerTapeList?.map((tickerContent, index) => {
                  return (
                    <li
                      key={`${tickerContent?.description}_${index}${index_outer}`}
                      className="list-disc pl-[22px] hover:underline first:list-none first:pl-0"
                    >
                      {tickerContent?.description &&
                        tickerContent?.destinationUrl && (
                          <a
                            target="_blank"
                            href={tickerContent?.destinationUrl}
                            className="text-primary-400 "
                            onClick={() => statsLog(tickerContent)}
                          >
                            {tickerContent?.description}
                          </a>
                        )}
                    </li>
                  );
                })}
              </ul>
            ))}
          </div>
        </div>
      </>
    )
  );
};

export default TickerTape;
